class Identity {
  constructor (attrs) {
    this.id = attrs.id
    this.name = attrs.name
    this.apiToken = attrs.apiToken
    // undefined (never chosen, e.g. a pre-existing identity) falls back to
    // CAD; an explicit empty string is the user choosing "no default" on
    // purpose, and stays empty rather than reverting to CAD.
    this.defaultCurrency = attrs.defaultCurrency === undefined ? 'CAD' : attrs.defaultCurrency
    this.selectedSheetId = attrs.selectedSheetId
  }
}

export default Identity
